module.exports = __webpack_public_path__ + "static/fipcneutraldinosaur-208e82ccaa6613dd8c66841992bd6dc1.jpeg";